
// Importing icons
import {
    LooksOne,
    LooksTwo
} from "@mui/icons-material";
import { Theme } from "@mui/material/styles/createTheme";

export const colorProps = (valid: boolean) => ({
    sx: { color: (theme: Theme) => valid ? theme.palette.success.main : theme.palette.error.main }
});

/**
 * Generates accessibility props for a tab.
 * 
 * @param {number} index - The index of the tab
 * @returns {Object} - Accessibility properties for the tab
 */
export const a11yProps = (index: number) => ({
    id: `action-tab-${index}`,
    "aria-controls": `action-tabpanel-${index}`,
});

/**
 * Returns the appropriate icon for a given tab index.
 * 
 * @param {number} index - The index of the tab
 * @param {boolean} valid - Validation state of the tab
 * @returns {JSX.Element} - The icon component for the tab
 */
export const getIcon = (index: number, valid: boolean): JSX.Element => {
    switch (index) {
        case 0: return <LooksOne {...colorProps(valid)} />;
        case 1: return <LooksTwo {...colorProps(valid)} />;

        default: return <LooksOne {...colorProps(valid)} />;
    }
};

/**
 * Returns the label for a given tab.
 * 
 * @param {string} label - The label of the tab
 * @returns {string} - The label for the tab
 */
export const getLabel = (label: string): string => label.replaceAll('_', ' ').replace('SIDE TAB', '');